// import Nfse from './Index.vue'
import Permissions from "../../models/Permissions";

const OCR = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: false,
  showInMenu: false,
  label: "Documentos",
  icon: "fa fa-files-o",
  group: "Arquivos",
  permissions,
};

export default [
  {
    path: "/OCR",
    name: "OCR",
    component: OCR,
    meta,
  },
];
